import styled, {keyframes} from 'styled-components';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const DottedLoadingBar = styled('div').withConfig({
  shouldForwardProp: interceptProps(['color']),
})<{
  color?: string;
}>`
  width: 56px;
  height: 56px;
  border-radius: 100%;
  border: dotted 4px ${({color}) => color || palette.primary400};
  animation: ${spin} 5s linear infinite;
`;
